/* @flow */
import { Observable } from 'rxjs';
import { fromJS, OrderedMap } from 'immutable';
import { combineEpics, ActionsObservable } from 'redux-observable';
import createDebugger from 'debug';
import { pipe, prop, path } from 'ramda';
import { parseServerErrorMessage } from 'trustar/utils';

const debug = createDebugger('app:modules:groups:epics'); // eslint-disable-line no-unused-vars

import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  EDIT,
  EDIT_SUCCESS,
  EDIT_FAILURE,
  DELETE,
  DELETE_SUCCESS,
  DELETE_FAILURE,
} from './action-types.js';
import { SharingGroup } from './types.js';

export const ENDPOINT = '/services/sharing-groups';

const fromJSON = (response: Array<Object>): OrderedMap<SharingGroup> => {
  return fromJS(response)
    .map(SharingGroup)
    .toOrderedMap()
    .mapKeys((k, v) => v.get('guid'));
};

const fetchEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(FETCH)
    .mergeMap(({ payload }) =>
      ajax.get(ENDPOINT)
        .map(prop('response'))
        .map(fromJSON)
        .map(groups => ({
          type: FETCH_SUCCESS,
          payload: groups,
        }))
        .catch(err => Observable.of({
          type: FETCH_FAILURE,
          error: true,
          payload: err,
        }))
    );

const saveEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(SAVE)
    .mergeMap(({ payload }) =>
      ajax.postJSON(ENDPOINT, payload.toJSON())
        .map(({ response }) => ({
          type: SAVE_SUCCESS,
          payload: pipe(fromJS, SharingGroup)(response),
          meta: {
            alert: { type: 'success', text: 'Sharing group saved.' },
          },
        }))
        .catch(err => Observable.of({
          type: SAVE_FAILURE,
          error: true,
          payload: err,
          meta: {
            alert: {
              type: 'error',
              text: (400 <= err.status && err.status < 500)
                    ? path(['xhr', 'response', 'message'], err)
                    : 'Could not save sharing group.'
            },
          },
        }))
    );

const updateEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(EDIT)
    .mergeMap(({ payload }) =>
      ajax.putJSON(`${ENDPOINT}/${payload.get('guid')}`, payload.toJSON())
        .map(({ response }) => ({
          type: EDIT_SUCCESS,
          payload: fromJS(response),
          meta: {
            alert: { type: 'success', text: 'Sharing group updated.' },
          },
        }))
        .catch(err => Observable.of({
          type: EDIT_FAILURE,
          error: true,
          payload: err,
          meta: {
            alert: {
              type: 'error',
              text: parseServerErrorMessage(err, 'Could not update sharing group.'),
            },
          },
        }))
    );

const deleteEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(DELETE)
    .mergeMap(({ payload }) =>
      ajax.delete(`${ENDPOINT}/${payload}`)
        .map(() => ({
          type: DELETE_SUCCESS,
          payload: String(payload),
          meta: {
            alert: { type: 'success', text: 'Sharing group removed.' },
          },
        }))
        .catch(err => Observable.of({
          type: DELETE_FAILURE,
          error: true,
          payload: err,
          meta: {
            alert: { type: 'error', text: 'Could not remove sharing group.' },
          },
        })));

export default combineEpics(
  fetchEpic,
  saveEpic,
  updateEpic,
  deleteEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/groups/epics.js